import { render, staticRenderFns } from "./groupmembers.vue?vue&type=template&id=12041dd4&scoped=true&"
import script from "./groupmembers.vue?vue&type=script&lang=js&"
export * from "./groupmembers.vue?vue&type=script&lang=js&"
import style0 from "./groupmembers.vue?vue&type=style&index=0&id=12041dd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12041dd4",
  null
  
)

export default component.exports